
  let free_cloveys_is_action = false;
  

  let has_mastery_clovey = document.querySelector('[data-mystery-clovey]');
  

  let handle_free_cloveys = async (page) => { 

    free_cloveys_is_action = true;

  
    

    let mistery_cloveys_ids = (JSON.parse(has_mastery_clovey.getAttribute('data-mystery-clovey'))).variants.map(v => v.id);



   

   
    let response = await fetch('/cart.js');
    let cartData = await response.json();
  
    let in_cart_mistery = [...cartData.items].find(ci => mistery_cloveys_ids.includes(ci.id));

    let is_in_cart = !!in_cart_mistery;
  
    if(!is_in_cart && cartData.total_price >= 5000) {

      let id = has_mastery_clovey.getAttribute('data-mistery-clovey-id');  
      let formData = {
        'items': [{
         'id': id,
         'quantity': 1
         }]
       };
       fetch(window.Shopify.routes.root + 'cart/add.js', {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json'
         },
         body: JSON.stringify(formData)
       })
       .then(response => {
         return response.json();
       }).then(data => { 
        document.dispatchEvent(new CustomEvent("product:added", {detail:{product:{id:id, quantity:1}}})); 

        if(page) {
          window.location.reload();
        }
       })
       .catch((error) => {
         console.error('Error:', error);
       });
    
    }  else if(is_in_cart && cartData.total_price < 5000 ) { 
  
      let id = in_cart_mistery.id;
      let updates = {
        [id]: 0
      };
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      })
      .then(response => {
        return response.json();
      }).then(data => {
        document.dispatchEvent(new CustomEvent("product:added", {detail:{product:{id, quantity:1}}}));
        if(page) {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }

    free_cloveys_is_action = false;


  }


  if(window.location.href.includes('cart') && window.run_free_item == true) { 
    setInterval(() => {
      handle_free_cloveys('cart-page'); 
    }, 100) 
  }
  
  
  
  




let cart_drawer_element = document.querySelector('#sidebar-cart');
let cd_config = {
    subtree: true,
    attributeOldValue: true
}
let handle_cart_drawer_cb  = async (mutationList) => {
    for (const mutation of mutationList) { 
       if(document.querySelector('[name="has_women_shoes"]')) {
         window.convert_women_shoes = true;
         window.VWO = window.VWO || []; 
         window.VWO.push(['activate', false, [122], true]);
       }
       if(document.querySelector('[name="has_men_shoes"]')) {
         window.convert_men_shoes = true;
       }

       if(document.querySelector('#sidebar-cart[aria-hidden="false"]')) {
        window.convert_cart = "open";

       }
    }
    


    if(!free_cloveys_is_action && has_mastery_clovey && window.run_free_item == true) { 
      handle_free_cloveys(); 
    }



    
}
let cart_drawer_observer = new MutationObserver(handle_cart_drawer_cb);
cart_drawer_observer.observe(cart_drawer_element, cd_config);


window.addEventListener('click', async (event) => {



  if(event.target.localName == 'label' && event.target.classList.contains('SizeSwatch') && window.innerWidth >= 1024 && document.querySelector('#shopify-section-collection-template')) {
    clarity("set", "atc", "destkopquickadd");
  }


  if(event.target.id == 'show-filters' || event.target.closest('#show-filters') || event.target.classList.contains('CollectionToolbar__Item--filter') || event.target.closest('.CollectionToolbar__Item--filter')) {

    clarity("set", "filters", "open")
  }



  if(event.target.hasAttribute('data-drawer-id') || event.target.closest('[data-drawer-id]')) {
    window.mobile_menu_open = true;
    clarity("set", "nav", "opened"); 
  }


if(event.target.classList.contains('nav-search-icon') || event.target.closest('.nav-search-icon')){
  window.search_used = true;

}


  if(event.target.id == 'Cart__Checkout') {

    event.preventDefault(); 

    let cart_response = await fetch('/cart.js');
    let cart_response_data = await cart_response.json();

    let total_price =  cart_response_data.total_price / 100;
    let product_count = cart_response_data.item_count;


    console.log(total_price, product_count);

    

  
    window._conv_q = window._conv_q || [];
    _conv_q.push(["pushRevenue", total_price, product_count, "100413414"]);

    window.location.href = '/checkout';

  }
  

});

function isMobile() {
  var match = window.matchMedia || window.msMatchMedia;
  if(match) {
      var mq = match("(pointer:coarse)");
      return mq.matches;
  }
  return false;
}


let handle_product_description_cb = (mutationList) => {


  let ab = localStorage.getItem('description_ab') != null; 



  if(!isMobile() && ab) { 
    let description = document.querySelector('#desktop-description');
    let atc = document.querySelector('#MainForm__AddToCart');
    atc.insertAdjacentElement('afterend', description);
  }


}










let product_description = document.querySelector('.Product__InfoWrapper');
let product_description_observer = new MutationObserver(handle_product_description_cb);

if(product_description) {
  product_description_observer.observe(product_description, cd_config);
}















